import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function AdmDeveloperSupport() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ type: "unlock_account", user_email_target: "", subject: "", details: "" });
  const refresh = () => api.get("/support-tickets").then(r=>setList(r.data));
  useEffect(()=>{ refresh(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/support-tickets", form); toast.success("Submitted to Developer"); setForm({type:"unlock_account",user_email_target:"",subject:"",details:""}); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Help</div><h1 className="font-display text-4xl text-white">Developer Support</h1>
      <p className="text-white/50 text-sm mt-2">Submit a request to the Developer team — for example, to unlock a user account or escalate a system issue.</p></div>
      <form onSubmit={submit} className="card-luxe p-6 grid md:grid-cols-2 gap-4">
        <div><div className="overline mb-1">Request Type</div><select className="input-box" value={form.type} onChange={(e)=>setForm({...form, type:e.target.value})}>
          <option value="unlock_account">Unlock User Account</option><option value="general">General</option><option value="urgent">Urgent / System Issue</option>
        </select></div>
        <div><div className="overline mb-1">Target User Email (if applicable)</div><input className="input-box" value={form.user_email_target} onChange={(e)=>setForm({...form, user_email_target:e.target.value})}/></div>
        <div className="md:col-span-2"><div className="overline mb-1">Subject</div><input required className="input-box" value={form.subject} onChange={(e)=>setForm({...form, subject:e.target.value})}/></div>
        <div className="md:col-span-2"><div className="overline mb-1">Details</div><textarea required rows={4} className="input-box resize-none" value={form.details} onChange={(e)=>setForm({...form, details:e.target.value})}/></div>
        <button className="btn-primary md:col-span-2"><Send size={13}/> Submit Request</button>
      </form>
      <div className="space-y-3">
        <div className="overline">My Recent Tickets</div>
        {list.map(t => (
          <div key={t.id} className="card-luxe p-4 flex justify-between gap-4">
            <div>
              <div className="text-white text-sm">{t.subject}</div>
              <div className="text-xs text-white/40">{t.type} · {new Date(t.created_at).toLocaleString()}</div>
              {t.developer_response && <div className="text-xs text-white/60 mt-1 italic">Reply: {t.developer_response}</div>}
            </div>
            <span className={`text-[10px] uppercase tracking-luxe self-start ${t.status==="resolved"? "text-[#32D74B]":"text-copper"}`}>{t.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
